module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonecvm-intro-card1.2.89225752.jpg";